import "angular-resource";
import "angular-local-storage";
import "angular-ui-router";
import "angular-animate";
import "angular-sanitize";
import "angular-aria";
import "ng-scrollbar";
import "angular-material-data-table";
import "angular-sortable-view";
import "ng-material-datetimepicker";
import "sortablejs";
import "angular-legacy-sortablejs-maintained";
import "angular-http-auth";
import "angular-loading-bar";
import "ngmap";
import "ng-file-upload";
import "ngclipboard";
import "angular-nvd3";
import "angular-translate";

import "nvd3/build/nv.d3.css";

import urls from "./urls";
import configs from "./configs";
import auth from "./auth";
import translationConfig from "./translationConfigs";

const modules = [
  "ui.router",
  "ngSanitize",
  "ngAnimate",
  "ngAria",
  "ngResource",
  "LocalStorageModule",
  "ngScrollbar",
  "md.data.table",
  "angular-sortable-view",
  "ngMaterialDatePicker",
  "ng-sortable",
  "http-auth-interceptor",
  "cfp.loadingBar",
  "ngSanitize",
  "ngMap",
  "ngFileUpload",
  "ngclipboard",
  "pascalprecht.translate",
  "nvd3",
];
export default angular
  .module("core", modules)
  .config(urls)
  .config(configs)
  .config(translationConfig)
  .run(auth);



// WEBPACK FOOTER //
// ./src/core/index.js